if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;


      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}


// Code for Mobile Filter option to open direct filter option.

const divs = document.querySelectorAll('.shopping-card__product');
divs.forEach(el => el.addEventListener('click', function(e) { 
  //  var target = e.target || e.srcElement;  
  console.log(e.target);
   var get_imgurl = e.target.getAttribute('data-mg-zoom-url');
   var get_imgurl_pos = e.target.getAttribute('data-media-position');
   //alert(get_imgurl_pos);
    //var get_menu_facet_op_details_id = document.querySelectorAll('.pro_mfp_gallery .mfp-content .mfp-img');        
    //get_img_popup_details = document.getElementById('mfp-img-popup');
    //get_img_popup_details.setAttribute('src',get_imgurl);
    document.body.classList.add('pro_thumb_popup_active');
    var get_active_mfg_element_id = 'mfp-img-popup-slide-item-'+get_imgurl_pos;
    var get_active_mfg_element = document.getElementById(get_active_mfg_element_id);
  
    var previous_img_btn = document.getElementById('image_mfp-arrow-left');
    previous_img_btn.setAttribute('data-media-position',get_imgurl_pos);
  
    const get_mfg_allElements = document.querySelectorAll('.mfp-img-popup-slide-item');
    
    get_mfg_allElements.forEach((element) => {
      element.classList.remove('active_mfp_block');
    });

    get_active_mfg_element.classList.add('active_mfp_block');

  
  /*
    let sibling_data_next_id = e.target.parentNode.nextElementSibling.id;
    console.log(sibling_data_next_id);   
    let sibling_data_previous_id = e.target.parentNode.previousElementSibling.id;  
    console.log(sibling_data_previous_id);   
    sibling_data_previous_img_block = document.getElementById(sibling_data_previous_id);
    var get_sibling_data_previous_imgurl = sibling_data_previous_img_block.getAttribute('data-mg-zoom-url');
    previous_img_btn = document.getElementById('image_mfp-arrow-left');
    previous_img_btn.setAttribute('data-mg-zoom-url',get_sibling_data_previous_imgurl);
    */
  /*
  let myReferenceDiv = document.getElementById('mydiv');
  let prev = myReferenceDiv.previousElementSibling;
  let next = myReferenceDiv.nextElementSibling;
*/

}));

const divs_gallery_left_btn = document.getElementById('image_mfp-arrow-left');
divs_gallery_left_btn.addEventListener('click', function(e) {
 
    const get_mfg_allElements = document.querySelectorAll('.mfp-img-popup-slide-item');

    const mfg_last_item = Array.from(
      document.querySelectorAll('.mfp-img-popup-slide-item')
    ).pop();
    var get_mfg_last_item_count = parseInt(mfg_last_item.getAttribute('data-mfg-img-pos'), 10);
    console.log(get_mfg_last_item_count); 
    console.log(e); 
   // alert(get_mfg_img_current_pos);
  
    get_mfg_allElements.forEach((element) => {
        let result = element.classList.contains('active_mfp_block');      
        if(result== true){

            //let sibling_data_active_id = e.target.parentNode.previousElementSibling.id;  
             
              let sibling_data_active_id = document.getElementById(element.id);          
              let sibling_data_previous_img_block = sibling_data_active_id.nextElementSibling;
              //alert(sibling_data_previous_img_block+' '+element.id+'left '+result); 
              var get_mfg_img_current_pos = parseInt(sibling_data_active_id.getAttribute('data-mfg-img-pos'), 10);  
              console.log('res');  
              console.log(parseInt(get_mfg_img_current_pos, 10));  
              //alert("Get Left "+get_mfg_img_current_pos);
              
              if((get_mfg_img_current_pos < get_mfg_last_item_count) && (get_mfg_img_current_pos > 1)){
                    var pre_slide_num = get_mfg_img_current_pos - 1;
      
                    var get_active_mfg_element_id = 'mfp-img-popup-slide-item-'+pre_slide_num;
                    var get_active_mfg_element = document.getElementById(get_active_mfg_element_id);
                  
                    var previous_img_btn = document.getElementById('image_mfp-arrow-left');
                    previous_img_btn.setAttribute('data-media-position',pre_slide_num);
                  
                    const get_mfg_allElements = document.querySelectorAll('.mfp-img-popup-slide-item');
                    
                    get_mfg_allElements.forEach((element) => {
                      element.classList.remove('active_mfp_block');
                    });
                
                    get_active_mfg_element.classList.add('active_mfp_block');
                                
                    //alert("Left "+pre_slide_num);
              }else if(get_mfg_img_current_pos == 1){
                    var pre_slide_num = get_mfg_last_item_count;
      
                    var get_active_mfg_element_id = 'mfp-img-popup-slide-item-'+pre_slide_num;
                    var get_active_mfg_element = document.getElementById(get_active_mfg_element_id);
                  
                    var previous_img_btn = document.getElementById('image_mfp-arrow-left');
                    previous_img_btn.setAttribute('data-media-position',pre_slide_num);
                  
                    const get_mfg_allElements = document.querySelectorAll('.mfp-img-popup-slide-item');
                    
                    get_mfg_allElements.forEach((element) => {
                      element.classList.remove('active_mfp_block');
                    });
                
                    get_active_mfg_element.classList.add('active_mfp_block');
                                
                    //alert("Left "+pre_slide_num);       
                    return;
              }else if(get_mfg_img_current_pos == get_mfg_last_item_count){
                    var pre_slide_num = get_mfg_last_item_count - 1;
      
                    var get_active_mfg_element_id = 'mfp-img-popup-slide-item-'+pre_slide_num;
                    var get_active_mfg_element = document.getElementById(get_active_mfg_element_id);
                  
                    var previous_img_btn = document.getElementById('image_mfp-arrow-left');
                    previous_img_btn.setAttribute('data-media-position',pre_slide_num);
                  
                    const get_mfg_allElements = document.querySelectorAll('.mfp-img-popup-slide-item');
                    
                    get_mfg_allElements.forEach((element) => {
                      element.classList.remove('active_mfp_block');
                    });
                
                    get_active_mfg_element.classList.add('active_mfp_block');
                                
                    //alert("Left "+pre_slide_num);                                                 
              }
          
            console.log(sibling_data_active_id);  
            console.log(sibling_data_previous_img_block);  
        }
        
    });
  

});


const divs_gallery_right_btn = document.getElementById('image_mfp-arrow-right');
divs_gallery_right_btn.addEventListener('click', function(e) {
 
    const get_mfg_allElements = document.querySelectorAll('.mfp-img-popup-slide-item');

    const mfg_last_item = Array.from(
      document.querySelectorAll('.mfp-img-popup-slide-item')
    ).pop();
    var get_mfg_last_item_count = parseInt(mfg_last_item.getAttribute('data-mfg-img-pos'), 10);
    console.log(get_mfg_last_item_count); 
    console.log(e); 
   // alert(get_mfg_img_current_pos);
  
    get_mfg_allElements.forEach((element) => {
        let result = element.classList.contains('active_mfp_block');      
        if(result== true){

            //let sibling_data_active_id = e.target.parentNode.previousElementSibling.id;  
             
              let sibling_data_active_id = document.getElementById(element.id);          
              let sibling_data_next_img_block = sibling_data_active_id.nextElementSibling;
              //alert(sibling_data_previous_img_block+' '+element.id+'left '+result); 
              var get_mfg_img_current_pos = parseInt(sibling_data_active_id.getAttribute('data-mfg-img-pos'), 10);  
              console.log('res');  
              console.log(parseInt(get_mfg_img_current_pos, 10));  
              //alert("Get Left "+get_mfg_img_current_pos);
              
              if((get_mfg_img_current_pos < get_mfg_last_item_count) && (get_mfg_img_current_pos > 1)){
                    var pre_slide_num = get_mfg_img_current_pos + 1;
      
                    var get_active_mfg_element_id = 'mfp-img-popup-slide-item-'+pre_slide_num;
                    var get_active_mfg_element = document.getElementById(get_active_mfg_element_id);
                  
                    var next_img_btn = document.getElementById('image_mfp-arrow-right');
                    next_img_btn.setAttribute('data-media-position',pre_slide_num);
                  
                    const get_mfg_allElements = document.querySelectorAll('.mfp-img-popup-slide-item');
                    
                    get_mfg_allElements.forEach((element) => {
                      element.classList.remove('active_mfp_block');
                    });
                
                    get_active_mfg_element.classList.add('active_mfp_block');
                                
                    //alert("Left "+pre_slide_num);
              }else if(get_mfg_img_current_pos == 1){
                    var pre_slide_num = get_mfg_img_current_pos + 1;
      
                    var get_active_mfg_element_id = 'mfp-img-popup-slide-item-'+pre_slide_num;
                    var get_active_mfg_element = document.getElementById(get_active_mfg_element_id);
                  
                    var next_img_btn = document.getElementById('image_mfp-arrow-right');
                    next_img_btn.setAttribute('data-media-position',pre_slide_num);
                  
                    const get_mfg_allElements = document.querySelectorAll('.mfp-img-popup-slide-item');
                    
                    get_mfg_allElements.forEach((element) => {
                      element.classList.remove('active_mfp_block');
                    });
                
                    get_active_mfg_element.classList.add('active_mfp_block');
                                
                    //alert("Left "+pre_slide_num);       
                    return;
              }else if(get_mfg_img_current_pos == get_mfg_last_item_count){
                    var pre_slide_num = 1;
      
                    var get_active_mfg_element_id = 'mfp-img-popup-slide-item-'+pre_slide_num;
                    var get_active_mfg_element = document.getElementById(get_active_mfg_element_id);
                  
                    var next_img_btn = document.getElementById('image_mfp-arrow-right');
                    next_img_btn.setAttribute('data-media-position',pre_slide_num);
                  
                    const get_mfg_allElements = document.querySelectorAll('.mfp-img-popup-slide-item');
                    
                    get_mfg_allElements.forEach((element) => {
                      element.classList.remove('active_mfp_block');
                    });
                
                    get_active_mfg_element.classList.add('active_mfp_block');
                                
                    //alert("Left "+pre_slide_num);                                                 
              }
          
            console.log(sibling_data_active_id);  
            console.log(sibling_data_previous_img_block);  
        }
        
    });
  

});

/*

const divs_gallery_left_btn = document.getElementById('image_mfp-arrow-left');
divs_gallery_left_btn.addEventListener('click', function(e) {
   var get_imgurl = e.target.getAttribute('data-mg-zoom-url');
    get_img_popup_details = document.getElementById('mfp-img-popup');
    get_img_popup_details.setAttribute('src',get_imgurl);  
  alert('left'+get_imgurl);
});
*/
const divs_gallery = document.querySelectorAll('.pro_mfp_gallery .mfp-container .mfp-close');
divs_gallery.forEach(el => el.addEventListener('click', event => {  
    document.body.classList.remove('pro_thumb_popup_active');
  //alert("close");
}));
